import CollectionPayload from '@libraries/api/change-password';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { getAdditionalHeader, IFetchData } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IChangePassword } from '@interfaces/iparam-change-password';

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);

    const postData = async (params: IChangePassword, accessToken?: string) => {
        let additionalHeader = getAdditionalHeader();
        const payload: IFetchData = CollectionPayload.post(params);

        if (accessToken) {
            additionalHeader = { ...additionalHeader, Authorization: `Bearer ${accessToken}` };
        }

        setIsLoader(true);
        let res: any = false;
        try {

            const response: any = await FetchData({ ...payload, additionalHeader });
            if (response.data.statusCode == 200 || response.data.statusCode == 201) {
                setIsLoader(false);
                notification.success({
                    message: 'Success',
                    duration: 5,
                    description: 'Berhasil update password!',
                });
                res = true;
            } else {
                setIsLoader(false);
                notification.error({
                    message: 'Failed',
                    duration: 5,
                    description: response.data.message || 'Gagal update password!',
                });
            }

        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "Gagal update password!",
                duration: 5,
                message: 'Failed',
            });
        }
        return res;
    };

    return {
        isLoader,
        setIsLoader,
        postData
    };
}



// WEBPACK FOOTER //
// ./src/pages/change-password/hooks/useAction.tsx